export default __webpack_public_path__ + "static/media/32.679459f0.jpeg";